import { useQuery } from '@tanstack/react-query';
import { fetchFranchiseAnalytics, fetchCityAnalytics } from '../api/analytics';
import type { FilterState } from '@/types/lead-attribution';
import type { FranchiseAnalytics, CityAnalytics } from '../types';

interface AnalyticsOptions {
  /** Only fetch when true - use for lazy loading tabs */
  enabled?: boolean;
}

/**
 * Hook for franchise analytics with lazy loading support
 * Set enabled=false to defer loading until user needs data
 */
export const useFranchiseAnalytics = (
  filters: FilterState,
  options: AnalyticsOptions = {}
) => {
  return useQuery<FranchiseAnalytics[]>({
    queryKey: ['jobber', 'analytics', 'franchise', filters],
    queryFn: () => fetchFranchiseAnalytics(filters),
    enabled: options.enabled !== false, // Default to true for backward compatibility
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });
};

/**
 * Hook for city analytics with lazy loading support
 * Set enabled=false to defer loading until user needs data
 */
export const useCityAnalytics = (
  filters: FilterState,
  options: AnalyticsOptions = {}
) => {
  return useQuery<CityAnalytics[]>({
    queryKey: ['jobber', 'analytics', 'city', filters],
    queryFn: () => fetchCityAnalytics(filters),
    enabled: options.enabled !== false, // Default to true for backward compatibility
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });
};
